// src/pages/CustomerProfilePage.jsx
const CustomerProfilePage = () => {
  return (
   <div className="w-full" style={{ height: "calc(100vh - 120px)" }}>
      <iframe
        src="https://clients.myvaluetrips.co.in"
        className="w-full h-full border-0"
        title="Customer Profile"
        allow="fullscreen"
      />
    </div>
  );
};

export default CustomerProfilePage;